import { render, staticRenderFns } from "./FullOfferBox.vue?vue&type=template&id=967e1146&scoped=true&"
import script from "./FullOfferBox.vue?vue&type=script&lang=js&"
export * from "./FullOfferBox.vue?vue&type=script&lang=js&"
import style0 from "./FullOfferBox.vue?vue&type=style&index=0&id=967e1146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967e1146",
  null
  
)

export default component.exports